import React from "react";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import Drawer from "@mui/material/Drawer";
import TextField from "@mui/material/TextField";
import { Box, Autocomplete, CircularProgress } from "@mui/material";

import {
  updateShowAttachToPartyDrawer,
  updateAttachPartyString,
  updateAttachPartyValue,
  postPaymentForNightAudit,
} from "../../reducer/nightAuditReducer";
import { getPartyList } from "../../reducer/partyReducer";
import { updateAddPartyDropdownVisible } from "../../reducer/expenseReducer";
import AddParty from "../bookingDetailsV2/components/AddParty";

import CloseIcon from "../../assets/images/svgs/CloseIcon.svg";
import { nightAuditdDawerWidth } from "../../utils/nightAuditHelper";
import { message } from "antd";
import moment from "moment";

const AttachToPartyDrawer = ({ selectedInvoice }) => {
  const [partyNames, setPartyNames] = useState([]);
  const [loading, setLoading] = useState(false);
  const [balanceDue, setBalanceDue] = useState("");

  const { hotelDetails } = useSelector((store) => store.login);
  const { showAttachToPartyDrawer, attachPartyString, attachPartyValue } =
    useSelector((store) => store.nightAudit);

  const { partyResponse, partyLoading } = useSelector((store) => store.party);
  const { addPartyDropdownVisible } = useSelector((store) => store.expense);
  const { currentNightAuditDate } = useSelector((store) => store.appHeader);

  const dispatch = useDispatch();

  useEffect(() => {
    const payload = {
      hotelId: hotelDetails?.id,
      pageSize: 30,
      searchText: attachPartyString,
      infiniteScrollDisabled: true,
    };
    dispatch(getPartyList(payload));
  }, [attachPartyString]);

  useEffect(() => {
    const updatedPartyNames = [];
    partyResponse?.forEach((party) => {
      const { displayName } = party;
      if (Boolean(displayName)) {
        updatedPartyNames.push(displayName);
      }
    });
    setPartyNames(updatedPartyNames);
  }, [partyResponse]);

  useEffect(() => {
    let total = selectedInvoice?.total;
    let paid = selectedInvoice?.paid;

    let due = total - paid;
    due = due > 0 ? due?.toFixed(2) : 0;

    if (due >= 0) {
      setBalanceDue(due);
    } else setBalanceDue(0);
  }, [showAttachToPartyDrawer]);

  const handleAttachToParty = async () => {
    if (!partyResponse || !partyResponse?.length) {
      message.info("Please select party first");
      return;
    }

    setLoading(true);

    let roomInvoice = selectedInvoice;

    let partyId = partyResponse?.find(
      (Obj) => Obj?.displayName === attachPartyValue
    )?.id;

    let updatedInvoice = JSON.parse(JSON.stringify(roomInvoice));
    updatedInvoice.partyId = partyId;

    const paymentPayload = {
      amount: balanceDue,
      bookingId: selectedInvoice?.bookingId,
      hotelId: hotelDetails?.id,
      invoiceId: updatedInvoice?.id,
      method: "btc",
      paymentModePartyId: partyId,
    };

    let zoneOffset = hotelDetails?.zoneOffset;

    const startOfDayWithOffset = moment(currentNightAuditDate)
      .startOf("day")
      .utcOffset(zoneOffset)
      .toISOString();

    const endOfDayWithOffset = moment(currentNightAuditDate)
      .endOf("day")
      .utcOffset(zoneOffset)
      .toISOString();

    let invoicePayload = {
      hotelId: hotelDetails?.id,
      pageNumber: 0,
      pageSize: 20,

      startDate: startOfDayWithOffset,
      endDate: endOfDayWithOffset,
    };

    const payload = {
      invoicePayload,
      paymentPayload,
    };

    dispatch(postPaymentForNightAudit(payload));

    dispatch(updateShowAttachToPartyDrawer(false));
    dispatch(updateAttachPartyString(""));
    dispatch(updateAttachPartyValue(""));

    await setLoading(false);
  };

  return (
    <Drawer
      PaperProps={{
        sx: {
          width: nightAuditdDawerWidth,
          borderTopLeftRadius: "10px",
          borderTopRightRadius: "10px",
        },
      }}
      sx={{
        "& .MuiDrawer-root": {
          position: "absolute",
          marginLeft: "auto",
          right: 0,
        },
        "& .MuiPaper-root": {
          position: "absolute",
          marginLeft: "auto",
        },
      }}
      anchor={"bottom"}
      open={showAttachToPartyDrawer}
      onClose={() => {
        dispatch(updateShowAttachToPartyDrawer(false));
        dispatch(updateAttachPartyString(""));
        dispatch(updateAttachPartyValue(""));
      }}
    >
      <div className="w-full px-[10px] pt-[10px] relative">
        <div className="flex w-[100%] justify-between items-center px-3 py-3 mb-[10px]">
          <h2 className="font-[500] text-[1rem] text-[#4D4D4D] font-nunito">
            Attach to Party
          </h2>

          <div
            onClick={() => dispatch(updateShowAttachToPartyDrawer(false))}
            className="cursor-pointer"
          >
            <img src={CloseIcon} alt="" />
          </div>
        </div>

        <div className="mb-[80px] relative">
          {addPartyDropdownVisible && (
            <AddParty
              updateAttachPartyValue={updateAttachPartyValue}
              partyType="source"
              inBookingDetails={true}
            />
          )}
          <Autocomplete
            id="party-select"
            sx={{
              width: "100%",
              "& .MuiOutlinedInput-root": {
                padding: "9px !important",
                borderRadius: "10px",
              },

              "& label": {
                color: "#0000004D",
                fontFamily: "Poppins",
                fontSize: "15px",
              },
              "& input": {
                fontFamily: "Poppins",
                fontSize: "0.75rem",
                fontWeight: "400",
                color: "#4D4D4D",
              },
              "& .MuiInputLabel-root": {
                display: "flex",
                justifyContent: "center",
                fontWeight: 200,
                alignItems: "center",
                fontFamily: "nunito",
                color: "#808080",
                fontSize: "12px", // Font size when label is down
                lineHeight: "16.37px",
              },
              "& .MuiInputLabel-shrink": {
                fontSize: "0.93rem", // Font size when label is up (focused)
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontFamily: "nunito",
              },
            }}
            options={
              partyNames?.length ? ["ADD PARTY", ...partyNames] : ["ADD PARTY"]
            }
            value={attachPartyValue}
            onChange={(event, newValue) => {
              if (newValue === "ADD PARTY") {
                dispatch(updateAddPartyDropdownVisible(true));
                return;
              }
              dispatch(updateAttachPartyValue(newValue));
            }}
            inputValue={attachPartyString}
            onInputChange={(event, newInputValue) => {
              dispatch(updateAttachPartyString(newInputValue));
            }}
            getOptionLabel={(option) => option}
            renderOption={(props, option) => (
              <Box
                component="li"
                {...props}
                sx={{
                  color: option === "ADD PARTY" ? "#007FFF" : "#000000B2",
                  fontWeight: "400",
                  fontSize: "14px",
                  lineHeight: "18px",
                  fontStyle: "Poppins",
                }}
              >
                {option}
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label={
                  <p>
                    Select Party <span className="text-[#007FFF]">*</span>
                  </p>
                }
                sx={{ borderRadius: 10 }}
                // style: inputStyle,
                inputProps={{
                  ...params.inputProps,
                  autoComplete: "new-password", // disable autocomplete and autofill
                }}
                loading={partyLoading}
              />
            )}
          />
        </div>

        <button
          className="w-full h-[53px] flex justify-center items-center bg-[#007fff] absolute bottom-0 left-0"
          onClick={handleAttachToParty}
          disabled={loading || partyLoading || !attachPartyValue}
        >
          {loading ? (
            <CircularProgress size={16} color="inherit" />
          ) : (
            <span className="text-[#fff] font-[600] text-[18px] leading-[18px]">
              SAVE DETAILS
            </span>
          )}
        </button>
      </div>
    </Drawer>
  );
};

export default AttachToPartyDrawer;
